'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  margin: 0 auto;\n  width: 90%;\n  ', '\n  }\n'], ['\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  margin: 0 auto;\n  width: 90%;\n  ', '\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n    width: 391px;\n  '], ['\n    width: 391px;\n  ']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: space-between;\n  margin: 40px 0 30px;\n'], ['\n  display: flex;\n  justify-content: space-between;\n  margin: 40px 0 30px;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  background-color: white;\n  border-radius: 3px;\n  box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);\n  margin-bottom: 40px;\n  margin-top: 15px;\n  padding: 30px 15px;\n  ', ';\n'], ['\n  background-color: white;\n  border-radius: 3px;\n  box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);\n  margin-bottom: 40px;\n  margin-top: 15px;\n  padding: 30px 15px;\n  ', ';\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n    padding: 30px 30px;\n  '], ['\n    padding: 30px 30px;\n  ']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 5px;\n  width: 95%;\n  border-radius: 7px;\n  cursor: pointer;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);\n  ', ';\n'], ['\n  margin-bottom: 5px;\n  width: 95%;\n  border-radius: 7px;\n  cursor: pointer;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);\n  ', ';\n']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n    width: 100%;\n  '], ['\n    width: 100%;\n  ']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  align-items: center;\n'], ['\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  align-items: center;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _wendysI18next = require('wendys-i18next');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsHelper = require('../../lib/styledComponentsHelper');

var _pageTitle = require('../pageTitle');

var _pageTitle2 = _interopRequireDefault(_pageTitle);

var _ADAHelpers = require('../../lib/ADAHelpers');

var _ADAHelpers2 = _interopRequireDefault(_ADAHelpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var flagSelectorProps = {
  handleFlagSelection: _propTypes2.default.func.isRequired
};

function FlagSelector(_ref) {
  var handleFlagSelection = _ref.handleFlagSelection;

  return _react2.default.createElement(
    FlagSelectorWrapper,
    null,
    _react2.default.createElement(_pageTitle2.default, { titleText: (0, _wendysI18next.getTranslatedString)('flag_selector_title') }),
    _react2.default.createElement(
      SignUpForm,
      null,
      _react2.default.createElement(
        'div',
        { className: 'sign-up-description', id: 'flag-selector-description' },
        (0, _wendysI18next.getTranslatedString)('flag_selector_description')
      ),
      _react2.default.createElement(
        FlagWrapper,
        null,
        _react2.default.createElement(
          Flag,
          null,
          _react2.default.createElement(Image, {
            tabIndex: '0',
            src: '/images/common/ic_flagUS.svg',
            alt: (0, _wendysI18next.getTranslatedString)('flag_selector_us_flag').value,
            onClick: function onClick() {
              return handleFlagSelection((0, _wendysI18next.getTranslatedString)('flag_selector_us_flag'), '/images/common/ic_flagUS.svg');
            },
            id: 'us-flag',
            onKeyDown: _ADAHelpers2.default.keyupHandler
          }),
          _react2.default.createElement(
            'span',
            { className: 'sign-up-description' },
            (0, _wendysI18next.getTranslatedString)('flag_selector_us_flag.value')
          )
        ),
        _react2.default.createElement(
          Flag,
          null,
          _react2.default.createElement(Image, {
            tabIndex: '0',
            src: '/images/common/ic_flagCA.svg',
            alt: (0, _wendysI18next.getTranslatedString)('flag_selector_ca_flag').value,
            onClick: function onClick() {
              return handleFlagSelection((0, _wendysI18next.getTranslatedString)('flag_selector_ca_flag'), '/images/common/ic_flagCA.svg');
            },
            id: 'ca-flag',
            onKeyDown: _ADAHelpers2.default.keyupHandler
          }),
          _react2.default.createElement(
            'span',
            { className: 'sign-up-description' },
            (0, _wendysI18next.getTranslatedString)('flag_selector_ca_flag.value')
          )
        )
      )
    )
  );
}

var FlagSelectorWrapper = _styledComponents2.default.div(_templateObject, _styledComponentsHelper.media.sm(_templateObject2));

var FlagWrapper = _styledComponents2.default.div(_templateObject3);

var SignUpForm = _styledComponents2.default.div(_templateObject4, _styledComponentsHelper.media.sm(_templateObject5));

var Image = _styledComponents2.default.img(_templateObject6, _styledComponentsHelper.media.sm(_templateObject7));

var Flag = _styledComponents2.default.div(_templateObject8);

FlagSelector.propTypes = flagSelectorProps;

exports.default = FlagSelector;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/loginComponents/FlagSelector.js
// module id = 308
// module chunks = 0